import React, { useState } from 'react';
import classnames from 'classnames';
import FacetValue from 'Shared/Facet/FacetValue';
import { translate } from 'Shared/translate';
import FacetAndOrFilter from 'Shared/Facet/FacetAndOrFilter';
import * as styles from './base.scss';
import Button from 'Shared/Button';
import Icon from 'Shared/Icon';
export const DEFAULT_VISIBLE_FACET_COUNT = 10;
export const POPULAR_FACET_COUNT = 5;
const ListPickerFacet = (props) => {
    const minItemsForSearch = 7;
    const minSearchQuery = 2;
    const maxHitsForSearch = 10;
    const [searchText, setSearchText] = useState('');
    const [sliceSearchedVaules, setSliceSearchedVaules] = useState(true);
    const { popularValues, alphabeticalValues } = props.filteredFacets();
    const someValuesAreHidden = props.someValuesAreHidden && alphabeticalValues.length > props.defaultVisibleFacetCount;
    const visibleAlphabeticalValues = someValuesAreHidden && (!searchText || searchText.length < minSearchQuery)
        ? alphabeticalValues.slice(0, props.defaultVisibleFacetCount)
        : alphabeticalValues;
    const completeList = popularValues.concat(visibleAlphabeticalValues);
    const searchInList = (facetValues) => {
        if (!searchText || searchText.length < minSearchQuery)
            return facetValues;
        if (sliceSearchedVaules)
            return facetValues.filter(x => x.text.toUpperCase().indexOf(searchText.toUpperCase()) >= 0).map(x => x).slice(0, maxHitsForSearch);
        return facetValues.filter(x => x.text.toUpperCase().indexOf(searchText.toUpperCase()) >= 0).map(x => x);
    };
    const searchHits = (facetValues) => {
        return facetValues.filter(x => x.text.toUpperCase().indexOf(searchText.toUpperCase()) >= 0).map(x => x).length;
    };
    const onSearchTextChange = (e) => {
        setSearchText(e.target.value);
        props.setMaxHeight(false);
    };
    const onKeyUp = (e) => {
        if (e.key === "Escape") {
            clear();
        }
    };
    const clear = () => {
        setSearchText('');
        props.setMaxHeight(false);
    };
    const onShowAllSearched = (showMore) => {
        !!showMore ? showAll() : showLess();
    };
    const showAll = () => {
        setSliceSearchedVaules(false);
        props.showAll();
    };
    const showLess = () => {
        setSliceSearchedVaules(true);
        props.showLess();
    };
    const showAllCondition = () => {
        return ((someValuesAreHidden) && (searchText.length < minSearchQuery)) || ((searchText.length >= minSearchQuery) && (searchHits(completeList) > maxHitsForSearch) && (sliceSearchedVaules === true));
    };
    const showLessCondition = () => {
        return (((visibleAlphabeticalValues.length > props.defaultVisibleFacetCount) && !someValuesAreHidden) && (searchText.length < minSearchQuery)) || ((searchText.length >= minSearchQuery) && (searchHits(completeList) > maxHitsForSearch) && (sliceSearchedVaules === false));
    };
    const facetValueList = (facetValues, listClassName = '') => facetValues.length > 0 ? (React.createElement("ul", { className: classnames(styles.values, listClassName) }, facetValues.map(facetValue => (React.createElement(FacetValue, Object.assign({ excludeCnt: props.excludeCnt, key: facetValue.fieldName + '-' + facetValue.id, onChange: (selected, element) => props.onFacetValueChange(facetValue, selected, element) }, facetValue)))))) : null;
    return (React.createElement("div", null,
        props.selectedFacetValues.length > 1 && props.facet.canToggleOrAnd && (React.createElement(FacetAndOrFilter, { fieldName: props.facet.fieldName, onAndOrFilterChange: props.onAndOrFilterChange, hasAndFilter: props.facet.hasAndFilter })),
        (completeList.length > minItemsForSearch) &&
            React.createElement("div", { className: styles.categorySearch },
                React.createElement(Icon, { className: styles.searchIcon, name: "categoryfilter-search" }),
                React.createElement("input", { type: "search", value: searchText, onChange: onSearchTextChange, onKeyUp: onKeyUp, placeholder: `${translate('/Shared/Search')} ${props.facet.displayName.toLowerCase()}` }),
                !!searchText && searchText.length > 0 &&
                    React.createElement(Button, { className: styles.closeIcon, onClick: () => clear(), appearance: "clear" },
                        React.createElement(Icon, { name: "close" }))),
        facetValueList(searchInList(completeList)),
        completeList.length <= 0 && React.createElement("div", { className: styles.noHits }, translate('/Shared/NoHits')),
        showAllCondition() && (React.createElement("div", { className: styles.showall },
            React.createElement("span", { onClick: () => onShowAllSearched(true) }, translate('/Shared/ShowAll')))),
        showLessCondition() && (React.createElement("div", { className: styles.showall },
            React.createElement("span", { onClick: () => onShowAllSearched(false) }, translate('/Shared/ShowLess'))))));
};
export default ListPickerFacet;
